import $ from 'jquery';
import { debounce } from './../../utils';
$(function () {
  var $header = $('.header');
  var headerHeight = $header.height();
  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  $(window).on('scroll', debounce(onScroll, 10));
  function onScroll() {
    var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (lastScrollTop > currentScrollTop || headerHeight * 2 > currentScrollTop) {
      $header.removeClass('collapse');
      lastScrollTop = currentScrollTop > 0 ? currentScrollTop : 0;
      return;
    }
    if (currentScrollTop > lastScrollTop) {
      $header.addClass('collapse');
    }
    lastScrollTop = currentScrollTop > 0 ? currentScrollTop : 0;
  }
});